import * as React from "react";
import type { SVGProps } from "react";
const SvgUserProfileLeft = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M2.4 21.6V18A3.6 3.6 0 0 1 6 14.4h6m5.57 3.9L15 15.9m0 0 2.57-2.4M15 15.9h6.6M14.4 6a3.6 3.6 0 1 1-7.2 0 3.6 3.6 0 0 1 7.2 0"
    />
  </svg>
);
export default SvgUserProfileLeft;
